import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getDownloadCenterList, postDownloadCenterDelete } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import { saveAs } from 'file-saver';
import { formatTimeToStr } from '@/utils/date';

var _this;

export default {
  name: 'DownloadCenter',
  components: {},
  data: function data() {
    return {
      loading: true,
      activeName: 'notApproved',
      auditStatus: false,
      searchInfo: {},
      tableData: [],
      status: 1,
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      form: {}
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.getTableData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 搜索 
    onSubmit: function onSubmit() {
      this.getTableData();
    },
    // 获取微信用户审核列表
    getTableData: function getTableData() {
      var _this3 = this;

      var obj = {
        'page': this.page,
        'pageSize': this.pageSize
      };
      getDownloadCenterList(obj).then(function (res) {
        if (res.code == 0) {
          _this3.tableData = res.data.list;
          _this3.total = res.data.total;
          _this3.loading = false;
        }
      }, function (err) {});
    },
    // 下载
    down: function down(row) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                saveAs(row.downloadUrl);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 删除用户
    cancel: function cancel(row) {
      var _this4 = this;

      var obj = {
        'ID': row.ID
      };
      postDownloadCenterDelete(obj).then(function (res) {
        _this4.getTableData();
      }, function (err) {});
    },
    // 分页处理
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    }
  }
};